module.exports = __webpack_public_path__ + "img/slot-2.3203ef99.png";